<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-row v-if="loaded">
      <b-col lg="12">
        <b-card class="mb-3 mx-2 shadow bg-light">
          <b-card-title title-tag="h6"
            >Mandats nécessitant l'envoi d'un courrier</b-card-title
          >
          <template v-for="(document, index) in documents">
            <div :key="index" v-if="document.mandats.length > 0">
              <h6>
                {{ document.mintitule
                }}<b-button
                  @click="
                    printDocuments(document.ID, document.mintitule, index)
                  "
                  class="ml-3"
                  size="sm"
                  icon
                  ><b-icon-printer-fill></b-icon-printer-fill
                ></b-button>
              </h6>
              <p>
                <i> {{ document.note }}</i>
              </p>
              <b-table
                small
                striped
                hover
                :items="document.mandats"
                :fields="fields"
              >
                <template v-slot:cell(ID)="data">
                  
                  <b-link
                    :to="{
                      name: 'warrantView',
                      params: { id: data.item.ID },
                    }"
                  >
                    {{ data.item.ID }}
                  </b-link>
                </template>
                <template v-slot:cell(restant)="data">
                  <span v-if="data.item.warning" class="mr-2"><i class="fad fa-exclamation-triangle text-danger"></i></span>
                  {{ Number(data.item.restant).toFixed(2) }} €
                </template>
                <template v-slot:cell(creancier)="data">
                  <b-link
                    :to="{
                      name: 'creditorView',
                      params: { id: data.item.creancierID },
                    }"
                  >
                    {{ data.item.creancier }}
                  </b-link>
                </template>
                <template v-slot:cell(debiteur)="data">
                  <b-link
                    :to="{
                      name: 'debtorView',
                      params: { id: data.item.debiteurID },
                    }"
                  >
                    {{ data.item.debiteur }}
                  </b-link>
                </template>
              </b-table>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      size="xl"
      :title="'Confirmation des courriers ' + type_courrier"
      id="confirm-courriers"
      hide-footer
      title-class="text-center"
    >
      <b-row class="mb-3">
        <b-col class="d-flex justify-content-start">
          <b-button
            @click="confirm_courriers()"
            variant="success"
            class="align-self-center"
            >Confirmer les courriers
            <b-icon
              v-if="busy_confirm"
              icon="arrow-clockwise"
              animation="spin"
            ></b-icon
          ></b-button>
          <b-checkbox
            @input="reloadPrintDocuments()"
            v-model="doEntete"
            class="align-self-center ml-3"
            >Avec entête</b-checkbox
          >
        </b-col>
      </b-row>

      <object
        style="width: 100%; height: 1000px"
        :data="pdf_courriers"
        type="application/pdf"
      >
        <embed :src="pdf_courriers" type="application/pdf" />
      </object>
    </b-modal>
  </div>
</template>

<script>
import warrants from "@/services/warrants";
import DateTime from "@/services/DateTime.js";
export default {
  name: "mailsToSend",
  data() {
    return {
      loaded: false,
      busy_confirm: false,
      dsmId: null,
      type_courrier: null,
      pdf_courriers: null,
      doEntete: null,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Documents",
          active: true,
        },
      ],
      documents: [],
      fields: [
        {
          key: "ID",
          label: "N° de mandat",
          sortable: true,
          class: "text-center",
          thStyle: "width:10%",
        },
        {
          key: "restant",
          label: "Restant dû",
          sortable: true,
          class: 'text-right',
          thStyle: "width:10%",
        },
        {
          key: "dsm_switch_date",
          label: "En attente depuis",
          sortable: true,
          class: "text-center",
          formatter: (value) => DateTime.humanDate(value),
          thStyle: "width:10%",
        },
        {
          key: "creancier",
          label: "Créancier",

          sortable: true,
          thStyle: "width:40%",
        },
        {
          key: "debiteur",
          label: "Debiteur",

          sortable: true,
          thStyle: "width:40%",
        },
        {
          key: "initiale",
          label: "Négociateur",
          sortable: true,
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    confirm_courriers() {
      this.busy_confirm = true;
      warrants
        .confirm_courriers({
          dsmId: this.dsmId,
        })
        .then(() => {
          this.busy_confirm = false;
          this.$bvModal.hide("confirm-courriers");
          this.load();
        });
    },
    reloadPrintDocuments() {
      warrants

        .print_md({
          dsmId: this.dsmId,
          doEntete: this.doEntete,
        })
        .then((response) => {
          this.busy = false;
          if (response.data.success) {
            this.pdf_courriers =
              this.$store.getters.url +
              "/upload/documents/md/" +
              response.data.pdf;
          }
          this.load();
        });
    },
    printDocuments(dsmId, intitule, index) {
      this.type_courrier = intitule;
      this.dsmId = dsmId;
      this.doEntete = this.documents[index].doEntete == "oui" ? true : false;
      warrants

        .print_md({
          dsmId: dsmId,
          doEntete: this.doEntete,
        })
        .then((response) => {
          this.busy = false;
          if (response.data.success) {
            this.pdf_courriers =
              this.$store.getters.url +
              "/upload/documents/md/" +
              response.data.pdf;
            this.$bvModal.show("confirm-courriers");
          }
        });
    },
    load() {
      warrants.documents().then((response) => {
        this.loaded = true;
        this.documents = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>